<template lang="pug">
.calendar_block
  CalendarHeader(:days='days')
  LoadingSpinner(
    :showContent='!loading'
    :size="100"
  )
    CalendarBody(:data="data", :days="days")
</template>

<script>
import CalendarHeader from './CalendarHeader';
import CalendarBody from './CalendarBody';
import { Spinner as LoadingSpinner } from '@/components/spinners';

export default {
  name: 'CalendarBlock',
  components: { CalendarBody, CalendarHeader, LoadingSpinner },
  props: {
    data: {},
    days: {},
    loading: Boolean,
  },
};
</script>

<style scoped lang="stylus">
.calendar_block
  display flex;
  flex-direction column
</style>


// WEBPACK FOOTER //
// CalendarBlock.vue?09623203